import { render, staticRenderFns } from "./agreement-header.component.vue?vue&type=template&id=5c6e9a64&scoped=true&"
import script from "./agreement-header.component.vue?vue&type=script&lang=ts&"
export * from "./agreement-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./agreement-header.component.vue?vue&type=style&index=0&id=5c6e9a64&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e9a64",
  null
  
)

export default component.exports